import { useRouter } from "next/dist/client/router";

type CompanyBodyProps = {
    edit: boolean;
    link: string;
};
export default function ({ edit, link }: CompanyBodyProps) {
    const router = useRouter();

    return (
        <>
            <h3 className="text-lg leading-6 font-medium text-black">
                Kompanija {edit ? "izmjenjena!" : "kreirana!"}
            </h3>
            <div className="mt-2 px-7 py-3">
                <p className="text-sm text-gray-dark">
                    Provjerite profil kompanije ili postavite oglas.
                </p>
            </div>
            <div className="items-center px-4 py-3">
                <button
                    onClick={() => router.push("/kreiraj/posao")}
                    id="ok-btn"
                    className="px-4 py-2 bg-green-500 text-white text-base font-medium rounded-md w-full mb-3 shadow-sm hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-300"
                >
                    Postavi oglas
                </button>
                <button
                    onClick={() => router.push(link)}
                    className="px-4 py-2 border-gray border text-base font-medium rounded-md w-full mb-3 shadow-sm focus:outline-none focus:ring-2 hover:bg-gray-light"
                >
                    Pogledaj Kompaniju
                </button>
            </div>
        </>
    );
}
